<template>
  <div class="page">
    <!-- if provider list is not empty -->
    <div class="provider" v-if="provider">
      <h2 class="header capitalize">
        <span v-if="provider.firstName">{{ provider.firstName.toLowerCase() }} </span>
        <span v-if="provider.middleName">{{ provider.middleName.toLowerCase() }} </span>
        <span v-if="provider.lastName">{{ provider.lastName.toLowerCase() }}</span>,
        {{ provider.title }}
      </h2>

      <provider-bio :specialty="$route.params.specialty" :provider="provider"></provider-bio>
      <div>
        <togglable-caret-header :data-bs-target="'#'+provider.lastName+provider.id" :show-caret="true">
          <a role="button" class="actBtn"><h3 id="activity-header" v-if="activities || citations">&nbsp;Activities</h3></a>
        </togglable-caret-header>
        <div :id="provider.lastName+provider.id" class="collapse">
          <provider-activities :activities="activities" :citations="citations" :npi="$route.params.id"></provider-activities>
        </div>
      </div>
    </div>

    <div v-if="providersLength === 0" class="void">
      <h1 class="filler-icon">
        <font-awesome-icon :icon="['fas', 'search-plus']"/>
      </h1>
      <p>No provider information available</p>
    </div>
  </div>

</template>

<script>
  import ProviderBio from './ProviderBio';
  // import ProviderVisits from './ProviderVisits';
  import ProviderActivities from './ProviderActivities';
  import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';

  import {mapActions, mapGetters} from 'vuex';
  import {getProviderCitationsByNpi,getProviderByNpi, getReportsByNpi} from '@/api/getters/provider';

  export default {
    name: "provider-page",
    components: {
      'provider-bio': ProviderBio,
      // 'provider-visits': ProviderVisits,
      'provider-activities': ProviderActivities,
      'togglable-caret-header': TogglableCaretHeader
    },
    data() {
      return {
        activities: null,
        provider: null,
        citations: null
      }
    },
    computed: {
      ...mapGetters('login', {
        taxonomiesFromStore: 'getTaxonomies',
        allData: 'getAllData',
      }),
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      // activities() {
      //   let activities = this.allData.npiActivities[this.$route.params.id];
      //   let sorted = {};
      //   // sort by date desc
      //   Object.keys(activities).sort((a,b)=>b-a).forEach(date => {
      //     sorted[date] = activities[date];
      //   });
      //   return sorted;
      // },
      taxonomies () {
        return _.orderBy(this.taxonomiesFromStore, 'specialOrClassName');
      },
      // provider () {
      //   if (this.$route.params.id) {
      //     let npi = this.$route.params.id;
      //     return getProviderByNpi(this.allData, npi);
      //   }
      // },
      reports () {
        if (this.$route.params.index) {
          let npi = this.$route.params.index;
          return getReportsByNpi(this.allData, npi);
        }
        return null
      },
      providersLength () {
        return Object.keys(this.allData.npis).length;
      }
    },
    beforeDestroy() {
      delete this.activities;
      this.activities = null;
      delete this.provider;
      this.provider = null;
      delete this.taxonomies;
      this.taxonomies = null;
      delete this.reports;
      this.reports = null;
      delete this.providersLength;
      this.providersLength = null;
    },
    methods: {
      ...mapActions('login/provider', [
        'updateCurrentProvider'
      ]),
      getProvider(id) {
        return getProviderByNpi(this.allData, id);
      },
      getCitations(id) {
        return getProviderCitationsByNpi(this.allData,id) || [];
      },
      getActivities(id) {
//        let activities = this.allData.npiActivities[id];
        let activities = this.allData.npiGroupings ? this.allData.npiGroupings[id] : undefined;
        let sorted = {};
        if(!activities)
          return sorted;
        // sort by date desc
        Object.keys(activities.map(Number)).sort((a,b)=>{
          if(activities[a]['lo'])
          {
            if(activities[b]['lo'])
            {
              if(activities[a]['lo'] == activities[b]['lo'])
              {
                if(activities[a]['hi'])
                {
                  if(activities[b]['hi'])
                  {
                    if(activities[a]['hi'] == activities[b]['hi'])
                      return 0;
                    else if(activities[a]['hi'] < activities[b]['hi'])
                      return -1;
                    else return 1;
                  }
                  else
                    return -1;
                }
                else
                  return -1;
              }
              else if(activities[a]['lo'] < activities[b]['lo'])
                return -1;
              else
                return 1;
            }
            else
              return 1;
          }
          else
            return -1;
        }).forEach(i => {
          let newkey = `${activities[i]['lo'] || 'Undated'} -- ${activities[i]['hi'] || 'Undated'}`;
          sorted[newkey] = activities[i];
        });
        /*
        Object.keys(activities).sort((a,b)=>b-a).forEach(date => {
          sorted[date] = activities[date];
        });
        */

        return sorted;
      },
      refresh() {
        let id = this.$route.params.id;
        let specialty = this.$route.params.specialty;
        if ( typeof id !== 'undefined' && typeof specialty !== 'undefined' ) {
          // update/refresh provider info
          this.provider = this.getProvider(id);
          this.activities = this.getActivities(id);
          this.citations = this.getCitations(id);
          this.updateCurrentProvider({id, specialty});
        }
      }
    },
    watch: {
      '$route.params.id' (id) {
        this.refresh();
      }
    },
    created() {
      this.refresh();
    }
  }
</script>

<style scoped lang="scss">
  #activity-header {
    padding-top: 0.2em;
  }
  .page {
    min-height: 80vh;
    margin: 0 auto;
  }

  .actBtn {
    display: inline-block;
    text-decoration: none;
    color: black;
  }

  .provider {
    border: 1px solid lightgray;
    border-radius: 5px;
    margin: 0 auto;
    width: 700px;
    text-align: left;
  }

  .header {
    text-align: center;
    color: #fff;
    font-size: 1.2em;
    padding: 5px 0;
    background-color: #007bff;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .void {
    color: gray;
    text-align: center;
    font-size: 1.5em;
    margin-top: 2.0em;

    .filler-icon {
      font-size: 2.5em;
    }
  }
  @media only screen and (max-width: 768px) {
    .provider {
      width: 100%;
    }
  }

</style>
